var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-c menu"},[_vm._l((_vm.menu_items),function(item,index){return _c('router-link',{key:index,class:[
      'item',
      item.class,
      { 'is-active': _vm.currentRouteName === item.name },
    ],attrs:{"to":`/profile/${item.name}`}},[_c('span',{class:item.class},[_vm._v(_vm._s(item.label))])])}),(_vm.displaySignout)?_c('div',{staticClass:"item",on:{"click":_vm.handleLogout}},[_c('span',[_vm._v("Sign out")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }